var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.visible
    ? _c(
        "a-drawer",
        {
          attrs: {
            visible: _vm.visible,
            closable: true,
            maskClosable: false,
            "body-style": { paddingBottom: "80px" },
            "drawer-style": { backgroundColor: "#f0f2f5" },
            width: "80%",
          },
          on: { close: _vm.onClose },
        },
        [
          _c(
            "a-descriptions",
            { attrs: { title: "绑定分账接收者账号" } },
            [
              _c("a-descriptions-item", { attrs: { label: "当前应用" } }, [
                _c("span", { staticStyle: { color: "red" } }, [
                  _vm._v(
                    _vm._s(_vm.appInfo.appName) +
                      " [" +
                      _vm._s(_vm.appInfo.appId) +
                      "]"
                  ),
                ]),
              ]),
              _c(
                "a-descriptions-item",
                { attrs: { label: "选择要加入到的账号分组" } },
                [
                  _c(
                    "a-select",
                    {
                      staticStyle: { width: "210px" },
                      attrs: { placeholder: "账号分组" },
                      model: {
                        value: _vm.selectedReceiverGroupId,
                        callback: function ($$v) {
                          _vm.selectedReceiverGroupId = $$v
                        },
                        expression: "selectedReceiverGroupId",
                      },
                    },
                    _vm._l(_vm.allReceiverGroup, function (item) {
                      return _c(
                        "a-select-option",
                        {
                          key: item.receiverGroupId,
                          attrs: { value: item.receiverGroupId },
                        },
                        [_vm._v(_vm._s(item.receiverGroupName))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("a-divider"),
          _c(
            "a-card",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.appSupportIfCodes.indexOf("wxpay") >= 0,
                  expression: "appSupportIfCodes.indexOf('wxpay') >= 0",
                },
              ],
              attrs: { title: "微信账号" },
            },
            [
              _c(
                "a",
                { attrs: { slot: "extra", href: "#" }, slot: "extra" },
                [
                  _c(
                    "a-button",
                    {
                      staticStyle: { background: "green", color: "white" },
                      attrs: { icon: "wechat" },
                      on: {
                        click: function ($event) {
                          return _vm.addReceiverRow("wxpay")
                        },
                      },
                    },
                    [_vm._v("添加【微信官方】分账接收账号")]
                  ),
                ],
                1
              ),
              _c("a-table", {
                attrs: {
                  columns: _vm.accTableColumns,
                  "data-source": _vm.receiverTableData.filter(
                    (item) => item.ifCode == "wxpay"
                  ),
                  pagination: false,
                  rowKey: "rowKey",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "reqBindStateSlot",
                      fn: function (record) {
                        return [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: record.reqBindState == 0,
                                  expression: "record.reqBindState == 0",
                                },
                              ],
                              staticStyle: { color: "salmon" },
                            },
                            [
                              _c("a-icon", { attrs: { type: "info-circle" } }),
                              _vm._v(" 待绑定 "),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: record.reqBindState == 1,
                                  expression: "record.reqBindState == 1",
                                },
                              ],
                              staticStyle: { color: "green" },
                            },
                            [
                              _c("a-icon", { attrs: { type: "check-circle" } }),
                              _vm._v(" 绑定成功 "),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: record.reqBindState == 2,
                                  expression: "record.reqBindState == 2",
                                },
                              ],
                              staticStyle: { color: "red" },
                            },
                            [
                              _c("a-icon", { attrs: { type: "close-circle" } }),
                              _vm._v(" 绑定异常 "),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                    {
                      key: "receiverAliasSlot",
                      fn: function (record) {
                        return [
                          _c("a-input", {
                            staticStyle: { width: "150px" },
                            attrs: { placeholder: "(选填)默认为账号" },
                            model: {
                              value: record.receiverAlias,
                              callback: function ($$v) {
                                _vm.$set(record, "receiverAlias", $$v)
                              },
                              expression: "record.receiverAlias",
                            },
                          }),
                        ]
                      },
                    },
                    {
                      key: "accTypeSlot",
                      fn: function (record) {
                        return [
                          _c(
                            "a-select",
                            {
                              staticStyle: { width: "110px" },
                              attrs: {
                                placeholder: "账号类型",
                                "default-value": "0",
                              },
                              model: {
                                value: record.accType,
                                callback: function ($$v) {
                                  _vm.$set(record, "accType", $$v)
                                },
                                expression: "record.accType",
                              },
                            },
                            [
                              _c("a-select-option", { attrs: { value: "0" } }, [
                                _vm._v("个人"),
                              ]),
                              _c("a-select-option", { attrs: { value: "1" } }, [
                                _vm._v("微信商户"),
                              ]),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                    {
                      key: "accNoSlot",
                      fn: function (record) {
                        return [
                          _c("a-input", {
                            staticStyle: { width: "150px" },
                            model: {
                              value: record.accNo,
                              callback: function ($$v) {
                                _vm.$set(record, "accNo", $$v)
                              },
                              expression: "record.accNo",
                            },
                          }),
                          record.accType == 0
                            ? _c(
                                "a-button",
                                {
                                  attrs: { type: "link" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.showChannelUserModal(
                                        "wxpay",
                                        record
                                      )
                                    },
                                  },
                                },
                                [_vm._v("扫码获取")]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                    {
                      key: "accNameSlot",
                      fn: function (record) {
                        return [
                          _c("a-input", {
                            model: {
                              value: record.accName,
                              callback: function ($$v) {
                                _vm.$set(record, "accName", $$v)
                              },
                              expression: "record.accName",
                            },
                          }),
                        ]
                      },
                    },
                    {
                      key: "relationTypeSlot",
                      fn: function (record) {
                        return [
                          _c(
                            "a-select",
                            {
                              staticStyle: { width: "110px" },
                              attrs: {
                                labelInValue: "",
                                placeholder: "分账关系类型",
                                defaultValue: { key: "PARTNER" },
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.changeRelationType(record, $event)
                                },
                              },
                            },
                            [
                              _c("a-select-option", { key: "PARTNER" }, [
                                _vm._v("合作伙伴"),
                              ]),
                              _c(
                                "a-select-option",
                                { key: "SERVICE_PROVIDER" },
                                [_vm._v("服务商")]
                              ),
                              _c("a-select-option", { key: "STORE" }, [
                                _vm._v("门店"),
                              ]),
                              _c("a-select-option", { key: "STAFF" }, [
                                _vm._v("员工"),
                              ]),
                              _c("a-select-option", { key: "STORE_OWNER" }, [
                                _vm._v("店主"),
                              ]),
                              _c("a-select-option", { key: "HEADQUARTER" }, [
                                _vm._v("总部"),
                              ]),
                              _c("a-select-option", { key: "BRAND" }, [
                                _vm._v("品牌方"),
                              ]),
                              _c("a-select-option", { key: "DISTRIBUTOR" }, [
                                _vm._v("分销商"),
                              ]),
                              _c("a-select-option", { key: "USER" }, [
                                _vm._v("用户"),
                              ]),
                              _c("a-select-option", { key: "SUPPLIER" }, [
                                _vm._v("供应商"),
                              ]),
                              _c("a-select-option", { key: "CUSTOM" }, [
                                _vm._v("自定义"),
                              ]),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                    {
                      key: "relationTypeNameSlot",
                      fn: function (record) {
                        return [
                          _c("a-input", {
                            attrs: {
                              disabled: record.relationType !== "CUSTOM",
                            },
                            model: {
                              value: record.relationTypeName,
                              callback: function ($$v) {
                                _vm.$set(record, "relationTypeName", $$v)
                              },
                              expression: "record.relationTypeName",
                            },
                          }),
                        ]
                      },
                    },
                    {
                      key: "divisionProfitSlot",
                      fn: function (record) {
                        return [
                          _c("a-input", {
                            staticStyle: { width: "65px" },
                            model: {
                              value: record.divisionProfit,
                              callback: function ($$v) {
                                _vm.$set(record, "divisionProfit", $$v)
                              },
                              expression: "record.divisionProfit",
                            },
                          }),
                          _vm._v(" % "),
                        ]
                      },
                    },
                    {
                      key: "opSlot",
                      fn: function (record) {
                        return [
                          _c(
                            "a-button",
                            {
                              attrs: { type: "link" },
                              on: {
                                click: function ($event) {
                                  return _vm.delRow(record)
                                },
                              },
                            },
                            [_vm._v("删除")]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  1021924501
                ),
              }),
            ],
            1
          ),
          _c("br"),
          _c(
            "a-card",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.appSupportIfCodes.indexOf("alipay") >= 0,
                  expression: "appSupportIfCodes.indexOf('alipay') >= 0",
                },
              ],
              attrs: { title: "支付宝账号" },
            },
            [
              _c(
                "a",
                { attrs: { slot: "extra", href: "#" }, slot: "extra" },
                [
                  _c(
                    "a-button",
                    {
                      staticStyle: { background: "dodgerblue", color: "white" },
                      attrs: { icon: "alipay-circle" },
                      on: {
                        click: function ($event) {
                          return _vm.addReceiverRow("alipay")
                        },
                      },
                    },
                    [_vm._v("添加【支付宝官方】分账接收账号")]
                  ),
                ],
                1
              ),
              _c("a-table", {
                attrs: {
                  columns: _vm.accTableColumns,
                  "data-source": _vm.receiverTableData.filter(
                    (item) => item.ifCode == "alipay"
                  ),
                  pagination: false,
                  rowKey: "rowKey",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "reqBindStateSlot",
                      fn: function (record) {
                        return [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: record.reqBindState == 0,
                                  expression: "record.reqBindState == 0",
                                },
                              ],
                              staticStyle: { color: "salmon" },
                            },
                            [
                              _c("a-icon", { attrs: { type: "info-circle" } }),
                              _vm._v(" 待绑定 "),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: record.reqBindState == 1,
                                  expression: "record.reqBindState == 1",
                                },
                              ],
                              staticStyle: { color: "green" },
                            },
                            [
                              _c("a-icon", { attrs: { type: "check-circle" } }),
                              _vm._v(" 绑定成功 "),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: record.reqBindState == 2,
                                  expression: "record.reqBindState == 2",
                                },
                              ],
                              staticStyle: { color: "red" },
                            },
                            [
                              _c("a-icon", { attrs: { type: "close-circle" } }),
                              _vm._v(" 绑定异常 "),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                    {
                      key: "receiverAliasSlot",
                      fn: function (record) {
                        return [
                          _c("a-input", {
                            staticStyle: { width: "150px" },
                            attrs: { placeholder: "(选填)默认为账号" },
                            model: {
                              value: record.receiverAlias,
                              callback: function ($$v) {
                                _vm.$set(record, "receiverAlias", $$v)
                              },
                              expression: "record.receiverAlias",
                            },
                          }),
                        ]
                      },
                    },
                    {
                      key: "accTypeSlot",
                      fn: function (record) {
                        return [
                          _c(
                            "a-select",
                            {
                              staticStyle: { width: "110px" },
                              attrs: {
                                placeholder: "账号类型",
                                "default-value": "0",
                              },
                              model: {
                                value: record.accType,
                                callback: function ($$v) {
                                  _vm.$set(record, "accType", $$v)
                                },
                                expression: "record.accType",
                              },
                            },
                            [
                              _c("a-select-option", { attrs: { value: "0" } }, [
                                _vm._v("个人"),
                              ]),
                              _c("a-select-option", { attrs: { value: "1" } }, [
                                _vm._v("商户"),
                              ]),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                    {
                      key: "accNoSlot",
                      fn: function (record) {
                        return [
                          _c("a-input", {
                            staticStyle: { width: "150px" },
                            model: {
                              value: record.accNo,
                              callback: function ($$v) {
                                _vm.$set(record, "accNo", $$v)
                              },
                              expression: "record.accNo",
                            },
                          }),
                          record.accType == 0
                            ? _c(
                                "a-button",
                                {
                                  attrs: { type: "link" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.showChannelUserModal(
                                        "alipay",
                                        record
                                      )
                                    },
                                  },
                                },
                                [_vm._v("扫码获取")]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                    {
                      key: "accNameSlot",
                      fn: function (record) {
                        return [
                          _c("a-input", {
                            model: {
                              value: record.accName,
                              callback: function ($$v) {
                                _vm.$set(record, "accName", $$v)
                              },
                              expression: "record.accName",
                            },
                          }),
                        ]
                      },
                    },
                    {
                      key: "relationTypeSlot",
                      fn: function (record) {
                        return [
                          _c(
                            "a-select",
                            {
                              staticStyle: { width: "110px" },
                              attrs: {
                                labelInValue: "",
                                placeholder: "分账关系类型",
                                defaultValue: { key: "PARTNER" },
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.changeRelationType(record, $event)
                                },
                              },
                            },
                            [
                              _c("a-select-option", { key: "PARTNER" }, [
                                _vm._v("合作伙伴"),
                              ]),
                              _c(
                                "a-select-option",
                                { key: "SERVICE_PROVIDER" },
                                [_vm._v("服务商")]
                              ),
                              _c("a-select-option", { key: "STORE" }, [
                                _vm._v("门店"),
                              ]),
                              _c("a-select-option", { key: "STAFF" }, [
                                _vm._v("员工"),
                              ]),
                              _c("a-select-option", { key: "STORE_OWNER" }, [
                                _vm._v("店主"),
                              ]),
                              _c("a-select-option", { key: "HEADQUARTER" }, [
                                _vm._v("总部"),
                              ]),
                              _c("a-select-option", { key: "BRAND" }, [
                                _vm._v("品牌方"),
                              ]),
                              _c("a-select-option", { key: "DISTRIBUTOR" }, [
                                _vm._v("分销商"),
                              ]),
                              _c("a-select-option", { key: "USER" }, [
                                _vm._v("用户"),
                              ]),
                              _c("a-select-option", { key: "SUPPLIER" }, [
                                _vm._v("供应商"),
                              ]),
                              _c("a-select-option", { key: "CUSTOM" }, [
                                _vm._v("自定义"),
                              ]),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                    {
                      key: "relationTypeNameSlot",
                      fn: function (record) {
                        return [
                          _c("a-input", {
                            attrs: {
                              disabled: record.relationType !== "CUSTOM",
                            },
                            model: {
                              value: record.relationTypeName,
                              callback: function ($$v) {
                                _vm.$set(record, "relationTypeName", $$v)
                              },
                              expression: "record.relationTypeName",
                            },
                          }),
                        ]
                      },
                    },
                    {
                      key: "divisionProfitSlot",
                      fn: function (record) {
                        return [
                          _c("a-input", {
                            staticStyle: { width: "65px" },
                            model: {
                              value: record.divisionProfit,
                              callback: function ($$v) {
                                _vm.$set(record, "divisionProfit", $$v)
                              },
                              expression: "record.divisionProfit",
                            },
                          }),
                          _vm._v(" % "),
                        ]
                      },
                    },
                    {
                      key: "opSlot",
                      fn: function (record) {
                        return [
                          _c(
                            "a-button",
                            {
                              attrs: { type: "link" },
                              on: {
                                click: function ($event) {
                                  return _vm.delRow(record)
                                },
                              },
                            },
                            [_vm._v("删除")]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  1081133777
                ),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "drawer-btn-center" },
            [
              _c(
                "a-button",
                {
                  style: { marginRight: "8px" },
                  attrs: { type: "primary", icon: "rocket" },
                  on: {
                    click: function ($event) {
                      return _vm.reqBatchBindReceiver(0)
                    },
                  },
                },
                [_vm._v("发起绑定请求")]
              ),
              _c(
                "a-button",
                { attrs: { icon: "close" }, on: { click: _vm.onClose } },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
          _c("ChannelUserModal", {
            ref: "channelUserModal",
            on: {
              changeChannelUserId: function ($event) {
                return _vm.changeChannelUserIdFunc($event)
              },
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }